import React from 'react';
import { Helmet } from './helmet';
import { useLocation } from 'react-router-dom';
import { pathnameShouldNoIndex } from '../../seo/noIndexRoutes';

/**
 * Applique noindex,nofollow sur les routes privées / transactionnelles.
 * Complète les meta page-spécifiques (ex. embed) sans les remplacer.
 */
const NoIndexRouteGuard: React.FC = () => {
  const { pathname } = useLocation();

  if (!pathnameShouldNoIndex(pathname)) {
    return null;
  }

  return (
    <Helmet>
      <meta name='robots' content='noindex, nofollow' />
    </Helmet>
  );
};

export default NoIndexRouteGuard;
